export default class Background {
    constructor(parent, router) {
        this.el = parent.el.querySelector('.bas-picture');
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
